import React, { Component } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";
import MainTheme from "./theme/MainTheme";
import withCustomStyles from "./App.style";
import MainWrapper from "./MainWrapper";
import { SnackbarProvider } from "notistack";
import { GButton } from "./parts/ui";

class App extends Component {
  notistackRef = React.createRef();

  render() {
    return (
      <ThemeProvider theme={MainTheme}>
        <Router>
          <SnackbarProvider
            maxSnack={1}
            ref={this.notistackRef}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            autoHideDuration={4000}
            hideIconVariant
            action={key => (
              <GButton
                variant="ghost"
                size="sm"
                className={this.props.classes.notistackText}
                onClick={() =>
                  this.notistackRef.current.handleDismissSnack(key)
                }
              >
                Dismiss
              </GButton>
            )}
            classes={{
              base: this.props.classes.base,
              message: this.props.classes.message,
              variantSuccess: this.props.classes.success,
              variantInfo: this.props.classes.info,
              variantWarning: this.props.classes.warning,
              variantError: this.props.classes.error
            }}
          >
            <MainWrapper />
          </SnackbarProvider>
        </Router>
      </ThemeProvider>
    );
  }
}

export default withCustomStyles(App);
